
import { isType, RuleSet, isString, isNonEmptyString, optional, isBool } from 'au-js-sdk/lib/types/typeguard';
export const PAYMENT_METHOD_CC = 'creditcard';
export const PAYMENT_METHOD_PAYPAL = 'paypal';
export const PAYMENT_METHOD_GIFTCARD = 'giftcard';
export const PAYMENT_METHOD_STORECREDIT = 'storecredit';
export const PAYMENT_METHOD_AFTERPAY = 'afterpay';
export const PAYMENT_METHOD_AMAZONPAY = 'amazonpay';

export type PaymentMethodCode =
  typeof PAYMENT_METHOD_CC |
  typeof PAYMENT_METHOD_PAYPAL |
  typeof PAYMENT_METHOD_GIFTCARD |
  typeof PAYMENT_METHOD_STORECREDIT |
  typeof PAYMENT_METHOD_AFTERPAY |
  typeof PAYMENT_METHOD_AMAZONPAY;

export const PAYMENT_METHODS = [
  PAYMENT_METHOD_CC,
  PAYMENT_METHOD_PAYPAL,
  PAYMENT_METHOD_GIFTCARD,
  PAYMENT_METHOD_STORECREDIT,
  PAYMENT_METHOD_AFTERPAY,
  PAYMENT_METHOD_AMAZONPAY
];

export interface CustomerPaymentMethod {
  type: PaymentMethodCode,
  token: string,
  email?: string,
  is_default: boolean,
  card_type?: string,
  cardholder?: string,
  is_expired: boolean,
  last4?: string,
  expiration_month?: string,
  expiration_year?: string,
  postcode?: string,
}
export const customerPaymentMethodRuleSet: RuleSet = {
  type: isNonEmptyString,
  token: isNonEmptyString,
  email: optional(isNonEmptyString),
  is_default: isBool,
  card_type: optional(isNonEmptyString),
  cardholder: optional(isNonEmptyString),
  is_expired: isBool,
  last4: optional(isNonEmptyString),
  expiration_month: optional(isNonEmptyString),
  expiration_year: optional(isNonEmptyString),
  postcode: optional(isNonEmptyString)
};

export const isCustomerPaymentMethod = (input: unknown): input is CustomerPaymentMethod =>
  isType<CustomerPaymentMethod>(input, customerPaymentMethodRuleSet);

export const isPaymentMethodCode = (input: unknown): input is PaymentMethodCode =>
  isString(input) && PAYMENT_METHODS.includes(input);